import EventBus from '@/plugIn/EventBus';
import {BvMsgBoxData} from 'bootstrap-vue/src/components/modal';
import {Promise} from 'es6-promise';

class AlertService {
  constructor() {
    console.log('creating new instance of AlertService');
  }

  // 참고 : https://jesusgalvan.medium.com/vue-js-event-bus-promises-f83e73a81d72
  showAlert(msg: string, title?: string): Promise<BvMsgBoxData> {
    const prms = new Promise<BvMsgBoxData>((resolve, reject) => {
      EventBus.$emit('showMsgBoxOk', msg, title, resolve, reject);
    });

    return prms;
  }

  showConfirm(
    msg: string,
    title?: string,
    modalId?: string,
    okTitle?: string,
    cancelTitle?: string,
  ): Promise<BvMsgBoxData> {
    const prms = new Promise<BvMsgBoxData>((resolve, reject) => {
      EventBus.$emit('showMsgBoxConfirm', msg, title, modalId, okTitle, cancelTitle, resolve, reject);
    });

    return prms;
  }
  hideMsgBoxConfirm(modalId: string) {
    EventBus.$emit('hideMsgBoxConfirm', modalId);
    return;
  }
}

// Export a singleton instance in the global namespace
export const alertService = new AlertService();
